export default function triggerMoreText() {
  const isPresent = document.querySelector("[data-toggle-more-btn]");
  if (!isPresent) {
    return;
  }

  const btns = document.querySelectorAll("[data-toggle-more-btn]");

  btns.forEach((btn) => {
    const text = btn.previousElementSibling;
    const textInitialSetHeight = text.getAttribute("data-toggle-more-text");

    const textInitialHeight = text.offsetHeight;

    if (textInitialHeight < textInitialSetHeight) {
      btn.classList.add("hidden");
    } else {
      btn.classList.remove("opacity-0");
    }

    btn.addEventListener("click", function () {
      const btnTextShow = btn.querySelector(".btn-toggle-more__show");
      const btnTextHide = btn.querySelector(".btn-toggle-more__hide");

      if (btnTextHide.classList.contains("hidden")) {
        // Expand the content
        btnTextHide.classList.remove("hidden");
        btnTextShow.classList.add("hidden");
        btn.classList.add("active");

        text.style.height = "auto";
      } else {
        // Collapse the content
        btnTextHide.classList.add("hidden");
        btnTextShow.classList.remove("hidden");
        btn.classList.remove("active");

        text.style.height = textInitialSetHeight + "px";

        // Smooth scroll to the section if the text is long
        if (text.scrollHeight > window.innerHeight) {
          const scrollTargetPosition =
            text.getBoundingClientRect().top + window.scrollY - 20; // Adjust -20 for padding
          window.scrollTo({
            top: scrollTargetPosition,
            behavior: "smooth",
          });
        }
      }
    });
  });
}
